module.exports = __webpack_public_path__ + "img/CCSLogo_Color.756d9e55.svg";